import { IPeople } from './IPeople';
import { peopleProperties } from './mapperConfig';
import { UtilityService } from '../../../infrastructure/services/utils';

/**
 * provide transformation functionality for people data using mapper configuration
 * @param   {Object} peopleItem transformed object
 */
export class PeopleMapper {
  peopleUser: IPeople = {};

  constructor(peopleProperty: [] = []) {
    this.peopleUser = UtilityService.getMappedProperties(
      peopleProperty,
      peopleProperties,
      this.peopleUser
    );
  }
}
